import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../services/api';

const RecoverPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await authService.forgotPassword({ email });
      window.alert(response.message || 'Se o e-mail existir, enviaremos as instrucoes de recuperacao.');
      navigate('/reset-password', { state: { email: email.trim() } });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Falha ao solicitar recuperacao de senha');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'var(--color-bg)',
      }}
    >
      <div
        style={{
          maxWidth: '400px',
          width: '100%',
          padding: '40px',
          backgroundColor: 'var(--color-bg-white)',
          borderRadius: 'var(--radius-md)',
          boxShadow: 'var(--shadow-card)',
        }}
      >
        <h2 style={{ textAlign: 'center', marginBottom: '12px', color: 'var(--color-primary)' }}>Recuperar senha</h2>
        <p style={{ textAlign: 'center', marginBottom: '24px', color: 'var(--color-text-light)' }}>
          Informe seu e-mail para receber o token de recuperacao.
        </p>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label
              style={{
                display: 'block',
                marginBottom: '5px',
                fontWeight: 'bold',
              }}
            >
              E-mail:
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '16px',
                boxSizing: 'border-box',
              }}
            />
          </div>
          {error && (
            <div
              style={{
                color: '#dc3545',
                marginBottom: '20px',
                padding: '10px',
                backgroundColor: '#f8d7da',
                border: '1px solid #f5c6cb',
                borderRadius: '4px',
              }}
            >
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: loading ? 'var(--color-text-muted)' : 'var(--color-primary)',
              color: 'var(--color-white)',
              border: 'none',
              borderRadius: 'var(--radius-sm)',
              fontSize: '16px',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background-color var(--transition-normal)',
            }}
          >
            {loading ? 'Enviando...' : 'Enviar token de recuperacao'}
          </button>
        </form>
        <div style={{ marginTop: '16px', textAlign: 'center' }}>
          <Link
            to="/login"
            style={{
              color: 'var(--color-primary)',
              textDecoration: 'none',
              fontWeight: 500,
            }}
          >
            Voltar para login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RecoverPassword;
